<template>
  <main class="container__brand">
    <div class="brand__header">
      <router-link to="/brands" class="go__back">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
      <img class="brand__logo" src="@/assets/img/brands/spetema/spetema.svg" alt="" />
      <img class="brand__bcg" src="@/assets/img/brands/spetema/spetema.svg" alt="" />
      <router-link to="/brandBalkam" class="go__back__right">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
    </div>

    <div class="container__clm">
      <Carousell
        :images="[
          require('../../assets/img/brands/spetema/p0.png'),
          require('../../assets/img/brands/spetema/p1.png'),
          require('../../assets/img/brands/spetema/p2.png'),
          require('../../assets/img/brands/spetema/p3.png'),
          require('../../assets/img/brands/spetema/p4.png'),
          require('../../assets/img/brands/spetema/p5.png'),
          require('../../assets/img/brands/spetema/p6.png'),
          require('../../assets/img/brands/spetema/p7.png'),
          require('../../assets/img/brands/spetema/p8.png'),
          require('../../assets/img/brands/spetema/p9.png'),
        ]"
      />
      <div class="brand__text">
        <div class="text">
          <!-- <h1>{{ $t('brands.spetema.title') }}</h1> -->
          <p>{{ $t('brands.spetema.desc') }}</p>
          <p>{{ $t('brands.spetema.desc1') }}</p>
          <br />
          <p class="continets__text">{{ $t('brands.spetema.title2') }}</p>
        </div>

        <div class="brand__continents">
          <img src="@/assets/img/brands/spetema/map-spetema.svg" alt="" />
        </div>
      </div>
    </div>
    <Button @click="redirect('https://coffeemall.bg/')" class="btn" type="button">{{ $t('buttons.button4') }}</Button>
  </main>
</template>

<script>
import Button from '@/components/Button';
import Carousell from '@/components/Carousell';
export default {
  components: {
    Button,
    Carousell,
  },
  data() {
    return {};
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
@import '@/scss/brands.scss';
.container__brand {
  background: #D89E49 0% 0% no-repeat padding-box;
}
</style>